<template>
  <section class="card_style mt-0">
    <div class="main_header_style">
      <div class="d-flex align-items-center gap-3">
        <AddFavDailog v-tooltip.left="$t('add_to_favourite')" />
        <h4 class="mb-0">{{ $t("add card") }}</h4>
      </div>
    </div>

    <form @submit.prevent="addAbout">
      <div class="row">
        <!-- Upload & Preview -->
        <div class="col-lg-12 col-12">
          <div class="upload-image">
            <input
              type="file"
              accept="image/*"
              @change="onFileChange"
              class="form-control"
            />

            <div v-if="Form.imagePreview" class="preview mt-2">
              <img :src="Form.imagePreview" alt="Preview" />
            </div>
          </div>
        </div>

        <!-- Title -->
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label>{{ $t("title") }}</label>
            <div class="accordion" id="accordionExample1">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                  >
                    {{ $t("title") }}
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample1"
                >
                  <div class="accordion-body">
                    <div
                      class="form-group"
                      v-for="(title, index) in Form.title"
                      :key="index"
                    >
                      <label>{{ $t("title") }} ({{ title.lang }})</label>
                      <input
                        type="text"
                        :placeholder="$t('name')"
                        class="form-control"
                        v-model="title.name"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <span
                class="text-danger"
                v-if="v$.Form.title.$error"
                v-text="v$.Form.title.$errors[0].$message"
              ></span>
            </div>
          </div>
        </div>

        <!-- Description -->
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label>{{ $t("describtion") }}</label>
            <div class="accordion" id="accordionExample2">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                  >
                    {{ $t("describtion") }}
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample2"
                >
                  <div class="accordion-body">
                    <div
                      class="form-group"
                      v-for="(desc, index) in Form.description"
                      :key="index"
                    >
                      <label class="mt-3">
                        {{ $t("describtion") }} ({{ desc.lang }})
                      </label>
                      <Editor v-model="desc.name" editorStyle="height: 120px" />
                    </div>
                  </div>
                </div>
              </div>
              <span
                class="text-danger"
                v-if="v$.Form.description.$error"
                v-text="v$.Form.description.$errors[0].$message"
              ></span>
            </div>
          </div>
        </div>
      </div>

      <!-- Submit -->
      <button type="submit" class="add btn PrimaryButton">
        {{ $t("add") }}
      </button>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Editor from "primevue/editor";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export default {
  name: "ClientOpinionAdd",
  components: { Editor, AddFavDailog },

  data() {
    return {
      v$: useVuelidate(),
      languages: ["ar", "en", "id"],

      Form: {
        description: [],
        title: [],
        image: null, // uploaded file
        imagePreview: null, // preview URL
      },
    };
  },

  validations() {
    return {
      Form: {
        title: this.Form.title.map(() => ({ name: { required } })),
        description: this.Form.description.map(() => ({ name: { required } })),
      },
    };
  },

  methods: {
    initForm() {
      this.Form.title = this.languages.map((lang) => ({ lang, name: "" }));
      this.Form.description = this.languages.map((lang) => ({
        lang,
        name: "",
      }));
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.Form.image = file;
      this.Form.imagePreview = URL.createObjectURL(file);
    },

    async addAbout() {
      this.v$.$validate();
      if (this.v$.$error) return;

      try {
        const formData = new FormData();

        this.Form.title.forEach((t) =>
          formData.append(`title_${t.lang}`, t.name)
        );
        this.Form.description.forEach((d) =>
          formData.append(`description_${d.lang}`, d.name)
        );

        if (this.Form.image instanceof File) {
          formData.append("image", this.Form.image);
        }

        const { data } = await axios.post(
          "/website/about_us_create_or_update",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        Swal.fire({ text: data.message, icon: "success" });
        this.$router.push("/header_about");
      } catch (error) {
        Swal.fire({ text: error.message, icon: "error" });
      }
    },

    async fetchAboutDetails() {
      try {
        const { data } = await axios.get("/fetch_about_us");
        console.log("Fetched:", data.data);
        this.Form.title = data.data.titles.map((about_title) => {
          return {
            lang: about_title.locale,
            name: about_title.title,
          };
        });

        this.Form.imagePreview = data.data.image;

        this.Form.description = data.data.descriptions.map((ele) => {
          return {
            lang: ele.locale,
            name: ele.description,
          };
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
  },

  mounted() {
    this.initForm();
    this.fetchAboutDetails();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style lang="scss" scoped>
.form-group {
  margin-bottom: 1rem;

  label {
    margin-bottom: 0.5rem;
  }
}

.upload-image {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.preview img {
  max-width: 250px;
  border-radius: 8px;
  border: 1px solid #ddd;
}

.main_header_style {
  margin-bottom: 0;
}
</style>
